"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.StyleBaseExporter = void 0;
var tslib_1 = require("tslib");
var base_1 = require("../../base");
var StyleBaseExporter = (function (_super) {
    tslib_1.__extends(StyleBaseExporter, _super);
    function StyleBaseExporter() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    StyleBaseExporter.prototype.export = function (style, styleIndex) {
        if (style.deleted)
            return;
        this.writer.writeWpStartElement('style');
        this.writer.writeWpStringAttr('type', this.getType());
        this.writer.writeWpStringAttr('styleId', this.getStyleId(styleIndex));
        if (styleIndex == 0)
            this.writer.writeWpBoolAttr('default', true);
        if (style.hidden)
            this.writer.writeWpEmptyElement('hidden');
        if (style.semihidden)
            this.writer.writeWpEmptyElement('semiHidden');
        this.exportStyleName(style);
        this.exportParentStyle(style);
        this.exportCore(style);
        this.writer.writeWpBoolValueAsTag('qFormat', style.primary);
        this.writer.endElement();
    };
    StyleBaseExporter.prototype.exportStyleName = function (style) {
        this.writer.writeWpStringValue('name', style.styleName);
    };
    StyleBaseExporter.prototype.exportParentStyle = function (style) {
        if (style.parent != null)
            this.writer.writeWpStringValue('basedOn', this.getStyleId(this.getStyleIndexByName(style.parent.styleName)));
    };
    return StyleBaseExporter;
}(base_1.BaseExporter));
exports.StyleBaseExporter = StyleBaseExporter;
